(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["luxury-editorial"] && !Shopify.designMode) return;
  try {
    
(function () {
  if (!('IntersectionObserver' in window)) {
    document.querySelectorAll('.le-reveal').forEach(function (el) {
      el.classList.add('is-visible');
    });
    return;
  }

  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.12 }
  );

  document.querySelectorAll('.le-reveal').forEach(function (el) {
    observer.observe(el);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ugc-video-feed"] && !Shopify.designMode) return;
  try {
    
class UgcVideoFeed extends HTMLElement {
  connectedCallback() {
    this._initAutoplay();
    this._initTapControl();
    this._initProgress();
    this._initShare();
    this._initCarousel();
  }

  disconnectedCallback() {
    if (this._observer) this._observer.disconnect();
  }

  /* Play when 50%+ visible; pause on leave */
  _initAutoplay() {
    const motionOk = !window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    if (!('IntersectionObserver' in window)) {
      if (motionOk) this.querySelectorAll('.ugc-video').forEach(v => v.play().catch(() => {}));
      return;
    }

    this._observer = new IntersectionObserver(
      (entries) => {
        entries.forEach(entry => {
          const video = entry.target.querySelector('.ugc-video');
          if (!video) return;
          if (entry.isIntersecting && motionOk) {
            video.play().catch(() => {});
          } else {
            video.pause();
          }
        });
      },
      { threshold: 0.5 }
    );

    this.querySelectorAll('.ugc-card').forEach(card => this._observer.observe(card));
  }

  /* Tap card body to pause / resume */
  _initTapControl() {
    this.querySelectorAll('.ugc-card').forEach(card => {
      const video = card.querySelector('.ugc-video');
      if (!video) return;

      card.addEventListener('click', (e) => {
        if (e.target.closest('.ugc-sidebar')) return;
        if (video.paused) {
          video.play().catch(() => {});
          card.classList.remove('ugc-card--paused');
        } else {
          video.pause();
          card.classList.add('ugc-card--paused');
        }
      });
    });
  }

  /* Drive the red progress bar from video.currentTime */
  _initProgress() {
    this.querySelectorAll('.ugc-card').forEach(card => {
      const video = card.querySelector('.ugc-video');
      const fill  = card.querySelector('.ugc-progress__fill');
      if (!video || !fill) return;

      video.addEventListener('timeupdate', () => {
        if (!video.duration) return;
        fill.style.width = (video.currentTime / video.duration * 100) + '%';
      });

      video.addEventListener('ended', () => { fill.style.width = '0%'; });
    });
  }

  /* Share button: Web Share API on mobile, open URL as fallback */
  _initShare() {
    this.querySelectorAll('.ugc-share-btn').forEach(btn => {
      btn.addEventListener('click', async (e) => {
        e.stopPropagation();
        const url = btn.dataset.url || window.location.href;

        if (navigator.share) {
          try {
            await navigator.share({ url });
          } catch {}
        } else if (url) {
          window.open(url, '_blank', 'noopener,noreferrer');
        }
      });
    });
  }

  /* Carousel prev / next */
  _initCarousel() {
    const wrap = this.querySelector('.ugc-wrap--carousel');
    if (!wrap) return;

    const prevBtn = this.querySelector('.ugc-nav__btn--prev');
    const nextBtn = this.querySelector('.ugc-nav__btn--next');
    if (!prevBtn || !nextBtn) return;

    const scroll = (dir) => {
      const card = wrap.querySelector('.ugc-card');
      if (!card) return;
      const gap = parseFloat(getComputedStyle(wrap).gap) || 4;
      wrap.scrollBy({ left: dir * (card.offsetWidth + gap), behavior: 'smooth' });
    };

    const update = () => {
      prevBtn.disabled = wrap.scrollLeft <= 1;
      nextBtn.disabled = wrap.scrollLeft + wrap.clientWidth >= wrap.scrollWidth - 1;
    };

    prevBtn.addEventListener('click', () => scroll(-1));
    nextBtn.addEventListener('click', () => scroll(1));
    wrap.addEventListener('scroll', update, { passive: true });
    update();
  }
}

if (!customElements.get('ugc-video-feed')) {
  customElements.define('ugc-video-feed', UgcVideoFeed);
}

  } catch(e) { console.error(e); }
})();
})();
